export type ActiveUsersSortBy =
  | 'first_name'
  | 'last_name'
  | 'email'
  | 'clinics'
  | 'title'
  | 'employee_type'
  | 'app_account_status'
  | 'last_login_time';

/**
 * Array of all ActiveUsersSortBy values.
 */
export const ACTIVEUSERSSORTBY_VALUES: readonly ActiveUsersSortBy[] = [
  'first_name',
  'last_name',
  'email',
  'clinics',
  'title',
  'employee_type',
  'app_account_status',
  'last_login_time',
] as const;
